import React from 'react';
import { Link } from 'react-router-dom';
import '../LandingPage.css'; // Assuming styles are still here

function Footer() {
  return (
    <footer className="footer" style={{
      width: '100%',
      maxWidth: '100%',
      boxSizing: 'border-box',
      overflowX: 'hidden',
      marginTop: 'auto'
    }}>
      <div className="footer-content">
        <p>&copy; {new Date().getFullYear()} EFSoft. All rights reserved.</p>
        <div className="footer-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/data-deletion">Data Deletion</Link>
          <Link to="/terms-of-service">Terms of Service</Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
